export class AppConf {

    constructor () {
        const {webStats} = window
        this._instance = window['webStats']
        this._publcRootUrl = webStats.publicRootUrl

    }

    static getInstance() {
        if (!this._instance) {
            this._instance = new AppConf()
        }
        return this._instance
    }
    static getPublicRootUrl() {
        let instance = AppConf.getInstance();
        return instance._publcRootUrl
    }
}


// WEBPACK FOOTER //
// ./src/AppConf.js